var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85637 19.8645C10.2351 20.2388 10.8457 20.2351 11.2201 19.8563C11.5943 19.4775 11.5907 18.8669 11.2119 18.4926L4.0991 11.4642L21.1431 11.4642C21.6757 11.4642 22.1074 11.0325 22.1074 10.5C22.1074 9.96739 21.6757 9.53568 21.1431 9.53568L4.10132 9.53568L11.2119 2.50951C11.5907 2.13517 11.5943 1.52458 11.2201 1.14581C10.8457 0.766944 10.2351 0.763375 9.85637 1.13761L1.24819 9.64368C0.770675 10.1155 0.770675 10.8865 1.24819 11.3585L9.85637 19.8645Z",
    fill: "#606062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.18117fbd0f9b60401dcdfffc23aaf7fe.svg";
export { ForwardRef as ReactComponent };